export default function unCamelCase(value) {
  return value.replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());
}
